import React, { useState, useEffect } from "react";
import "@/App.css";
import { Menu, X } from "lucide-react";

// Artist/Brand data
const brandInfo = {
  name: "Street Art Pirineus",
  bio: "Artista i pintor amb més de 15 anys d'experiència creant obres que capturen l'essència de la llum i el color. El meu treball explora la intersecció entre el clàssic i el contemporani, fusionant tècniques tradicionals amb visions modernes."
};

// Obra Propia (Personal artworks)
const personalArtworks = [
{
  id: 1,
  title: "North West Walls",
  category: "Bèlgica",
  year: "2025",
  image: "https://customer-assets.emergentagent.com/job_creative-studio-321/artifacts/ejz6kuya_1.jpeg"
},
{
  id: 2,
  title: "North West Walls",
  category: "Bèlgica",
  year: "2025",
  image: "https://customer-assets.emergentagent.com/job_creative-studio-321/artifacts/xz7k40f8_2.jpeg"
},
{
  id: 3,
  title: "Minifest",
  category: "La Seyne sur Mèr, França",
  year: "2024",
  image: "https://customer-assets.emergentagent.com/job_creative-studio-321/artifacts/0o9k95sx_3.jpg"
},
{
  id: 4,
  title: "Ogern",
  category: "Catalunya",
  year: "2024",
  image: "https://customer-assets.emergentagent.com/job_creative-studio-321/artifacts/p63e3rl4_4.jpg"
},
{
  id: 5,
  title: "Kromatik Festival",
  category: "Sant Andreu de la Barca",
  year: "2025",
  image: "https://customer-assets.emergentagent.com/job_creative-studio-321/artifacts/1g0uamfj_5.jpg"
},
{
  id: 6,
  title: "Museu del Gat",
  category: "Escaldes, Andorra",
  year: "2024",
  image: "https://customer-assets.emergentagent.com/job_creative-studio-321/artifacts/dyoipcqk_6.jpg"
},
{
  id: 7,
  title: "Graffitea Cheste",
  category: "València",
  year: "2024",
  image: "https://customer-assets.emergentagent.com/job_creative-studio-321/artifacts/44kt6n8w_7.jpeg"
},
{
  id: 8,
  title: "SucoArtFest",
  category: "León, Espanya",
  year: "",
  image: "https://customer-assets.emergentagent.com/job_creative-studio-321/artifacts/9fbkjt7t_8.jpeg"
},
{
  id: 9,
  title: "La Seu d'Urgell",
  category: "",
  year: "2023",
  image: "https://customer-assets.emergentagent.com/job_creative-studio-321/artifacts/aia06p0a_9.jpg"
},
{
  id: "9b",
  title: "La Seu d'Urgell",
  category: "",
  year: "2023",
  image: "https://customer-assets.emergentagent.com/job_creative-studio-321/artifacts/3z415pzu_9b.jpg"
},
{
  id: 10,
  title: "Cambrils d'Odèn",
  category: "Catalunya",
  year: "2023",
  image: "https://customer-assets.emergentagent.com/job_creative-studio-321/artifacts/smsa36dc_10.jpeg"
},
{
  id: 11,
  title: "Meninas Festival",
  category: "Ferrol, Espanya",
  year: "2022",
  image: "https://customer-assets.emergentagent.com/job_creative-studio-321/artifacts/jrrwa63x_11.jpeg"
},
{
  id: 12,
  title: "Torrefarrera Streetart Festival (1r premi)",
  category: "Catalunya",
  year: "2022",
  image: "https://customer-assets.emergentagent.com/job_creative-studio-321/artifacts/ssd8emu1_12.jpeg"
}];


// Projectes Comercials (Commercial projects for businesses)
const commercialProjects = [
{
  id: 1,
  image: "/images/StreetartPirineus/Projectes Comercials/1.jpeg", //main image
},
{
  id:"1b",
  title: "Cooperativa del Cadí",
  client: "La Seu d'Urgell",
  year: "2025",
  image: "/images/StreetartPirineus/Projectes Comercials/1b.png", //second image (for double image)
},
{
  id: 2,
  image: "/images/StreetartPirineus/Projectes Comercials/2.jpeg",
},
{
  id: "2b",
  image: "/images/StreetartPirineus/Projectes Comercials/2b.jpeg",
},
{
  id: "2c",
  title: "Cooperativa Pirenaica",
  client: "La Seu d'Urgell",
  year: "2024",
  image: "/images/StreetartPirineus/Projectes Comercials/2c.jpeg",
},
{
  id: 3,
  title: "Camió Integra Pirineus",
  year: "2023",
  image: "/images/StreetartPirineus/Projectes Comercials/3.jpg",
},
{
  id: 4,
  title: "Mural Tradicional Castellciutat",
  year: "2021",
  image: "/images/StreetartPirineus/Projectes Comercials/4.jpg",
},
{
  id: 5,
  title: "Adrall",
  year: "2023",
  image: "/images/StreetartPirineus/Projectes Comercials/5.jpg",
},
{
  id: 6,
  title: "Exhibició Copa del món BTT Pal-Arinsal",
  year: "2024",
  image: "/images/StreetartPirineus/Projectes Comercials/6.jpeg",  
},
{
  id: 7,
  title: "Bassella Experience",
  year: "2025",
  image: "/images/StreetartPirineus/Projectes Comercials/7.jpeg",
},
{
  id: 8,
  title: "Mural Monet custom",
  year: "2023",
  image: "/images/StreetartPirineus/Projectes Comercials/8.jpeg",
},
{
  id: 9,
  image: "/images/StreetartPirineus/Projectes Comercials/9.jpeg",
},
{
  id: "9b",
  image: "/images/StreetartPirineus/Projectes Comercials/9b.jpeg",
},
{
  id: "9c",
  title: "Custom Van",
  year: "2023",
  image: "/images/StreetartPirineus/Projectes Comercials/9c.jpeg",
},
{
  id: 10,
  title: "Mural Tradicional Caramelles Castellciutat",
  year: "2021",
  image: "/images/StreetartPirineus/Projectes Comercials/10.jpeg",
}];


// Interiors
const interiorsProjects = [
{
  id: 1,
  image: "/images/StreetartPirineus/Interiors/0.jpeg",
},
{
  id: "1b",
  title: "Urban Gym",
  year: "2025",
  image: "/images/StreetartPirineus/Interiors/0b.jpeg",
},
{
  id: 2,
  title: "Cal Serni",
  year: "2024",
  image: "/images/StreetartPirineus/Interiors/1.jpeg",
},
{
  id: 3,
  title: "Kidd Keo Live Graffiti",
  category: "Discoteca Big Ben, Mollerussa",
  year: "2025",
  image: "/images/StreetartPirineus/Interiors/2.jpeg",
},
{
  id: 4,
  image: "/images/StreetartPirineus/Interiors/3.jpeg",
},
{
  id: "4b",
  image: "/images/StreetartPirineus/Interiors/3b.jpeg",
},
{
  id: "4c",
  image: "/images/StreetartPirineus/Interiors/3c.jpeg",
},
{
  id: "4d",
  title: "Interior Integra Pirineus",
  year: "2024",
  image: "/images/StreetartPirineus/Interiors/3d.jpeg",
},
{
  id: 5,
  title: "Photocall Fira Sant Ermengol",
  year: "2025",
  image: "/images/StreetartPirineus/Interiors/4.jpeg",
},
{
  id: 6,
  image: "/images/StreetartPirineus/Interiors/5.jpeg",
},
{
  id: 6,
  title: "Granja Prats i Sansó",
  year: "2021",
  image: "/images/StreetartPirineus/Interiors/5b.jpeg",
},
{
  id: 7,
  title: "Leiva Pastisseria",
  year: "2021",
  image: "/images/StreetartPirineus/Interiors/6.jpeg",
},
{
  id: 8,
  title: "Carrossa Photocall Cadí 3d",
  year: "2025",
  image: "/images/StreetartPirineus/Interiors/7.jpeg",
},
{
  id: 9,
  title: " El magatzem",
  year: "2025",
  image: "/images/StreetartPirineus/Interiors/8.jpeg",
}];


// Navigation Component
const Navigation = () => {
  const [activeSection, setActiveSection] = useState("personal");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["personal", "commercial", "interiors", "contacte"];
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
  { id: "personal", label: "Obra Pròpia" },
  { id: "commercial", label: "Projectes Comercials" },
  { id: "interiors", label: "Interiors" },
  { id: "contacte", label: "Contacte" }];


  const handleNavClick = (id) => {
    setMobileMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* Desktop Navigation */}
      <nav
        data-testid="desktop-navigation"
        className="hidden md:flex fixed left-0 top-0 h-full w-52 lg:w-60 bg-[#F2ECE4] border-r border-[#E0D6CC] z-50 flex-col">

        <div className="p-6 lg:p-8">
          <a
            href="#personal"
            className="font-serif text-lg lg:text-xl text-[#1A1A1A] tracking-tight hover:text-[#C5A059] transition-colors leading-tight block"
            data-testid="logo-link">

            Street Art<br />Pirineus
          </a>
        </div>

        <div className="flex-1 flex flex-col justify-center px-6 lg:px-8">
          <div className="flex flex-col gap-5">
            {navItems.map((item) =>
            <a
              key={item.id}
              href={`#${item.id}`}
              data-testid={`nav-${item.id}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(item.id);
              }}
              className={`font-sans text-xs tracking-wider uppercase transition-all duration-300 ${
              activeSection === item.id ?
              "text-[#C5A059] font-medium" :
              "text-[#5A5A5A] hover:text-[#1A1A1A]"}`
              }>

                {item.label}
              </a>
            )}
          </div>
        </div>

        <div className="p-6 lg:p-8">
          <div className="w-8 h-[1px] bg-[#C5A059]"></div>
        </div>
      </nav>

      {/* Mobile Navigation */}
      <nav
        data-testid="mobile-navigation"
        className="md:hidden fixed top-0 left-0 right-0 bg-[#F2ECE4]/95 backdrop-blur-sm border-b border-[#E0D6CC] z-50">

        <div className="flex items-center justify-between px-4 py-4">
          <a
            href="#personal"
            className="font-serif text-base text-[#1A1A1A] tracking-tight"
            data-testid="mobile-logo-link">

            Street Art Pirineus
          </a>
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="p-2 text-[#1A1A1A]"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu">

            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {mobileMenuOpen &&
        <div
          className="absolute top-full left-0 right-0 bg-[#F2ECE4] border-b border-[#E0D6CC] shadow-lg"
          data-testid="mobile-menu-dropdown">

            <div className="flex flex-col py-4">
              {navItems.map((item) =>
            <a
              key={item.id}
              href={`#${item.id}`}
              data-testid={`mobile-nav-${item.id}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(item.id);
              }}
              className={`px-6 py-3 font-sans text-sm tracking-wider uppercase transition-all duration-300 ${
              activeSection === item.id ?
              "text-[#C5A059] bg-[#F9F5F1]" :
              "text-[#5A5A5A] hover:text-[#1A1A1A] hover:bg-[#F9F5F1]"}`
              }>

                  {item.label}
                </a>
            )}
            </div>
          </div>
        }
      </nav>
    </>);

};

// Gallery Item Component - Large image with info below (no crop, no background)
const GalleryItem = ({ image, title, subtitle, year, showInfo = true }) => {
  return (
    <div className={showInfo ? "mb-12 md:mb-16" : "mb-4 md:mb-6"} data-testid="gallery-item">
      <div>
        <img
          src={image}
          alt={title}
          className="w-full h-auto max-h-[85vh] object-contain" />
      </div>
      {showInfo && (
        <div className="mt-4 md:mt-6 text-center">
          <h3 className="font-serif text-xl md:text-2xl text-[#1A1A1A] mb-1">
            {title}
          </h3>
          <p className="text-[#5A5A5A] font-sans text-sm">
            {subtitle}{subtitle && year ? ' · ' : ''}{year}
          </p>
        </div>
      )}
    </div>);
};

// Obra Pròpia Section
const ObraPropiaSection = () => {
  return (
    <section
      id="personal"
      className="pt-20 md:pt-0 md:pl-52 lg:pl-60 min-h-screen"
      data-testid="personal-section">

      <div className="max-w-5xl mx-auto px-6 md:px-12 py-12 md:py-20">
        <div className="mb-12 md:mb-20">
          <p className="text-[#C5A059] font-sans text-xs tracking-[0.2em] uppercase mb-3">
            Col·lecció Personal
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#1A1A1A]">
            Obra Pròpia
          </h2>
        </div>

        {/* North West Walls - 2 images grouped (id 1 & 2) */}
        <div className="mb-12 md:mb-16">
          <GalleryItem
            image={personalArtworks[0].image}
            title={personalArtworks[0].title}
            subtitle={personalArtworks[0].category}
            year={personalArtworks[0].year}
            showInfo={false}
          />
          <GalleryItem
            image={personalArtworks[1].image}
            title={personalArtworks[0].title}
            subtitle={personalArtworks[0].category}
            year={personalArtworks[0].year}
            showInfo={true}
          />
        </div>

        {/* Individual artworks (id 3-8) */}
        {personalArtworks.slice(2, 8).map((artwork) => (
          <GalleryItem
            key={artwork.id}
            image={artwork.image}
            title={artwork.title}
            subtitle={artwork.category}
            year={artwork.year}
            showInfo={true}
          />
        ))}

        {/* Mural 9 - 2 images grouped (id 9 & 9b) */}
        <div className="mb-12 md:mb-16">
          <GalleryItem
            image={personalArtworks[8].image}
            title={personalArtworks[8].title}
            subtitle={personalArtworks[8].category}
            year={personalArtworks[8].year}
            showInfo={false}
          />
          <GalleryItem
            image={personalArtworks[9].image}
            title={personalArtworks[8].title}
            subtitle={personalArtworks[8].category}
            year={personalArtworks[8].year}
            showInfo={true}
          />
        </div>

        {/* Remaining artworks (id 10-11) */}
        {personalArtworks.slice(10).map((artwork) => (
          <GalleryItem
            key={artwork.id}
            image={artwork.image}
            title={artwork.title}
            subtitle={artwork.category}
            year={artwork.year}
            showInfo={true}
          />
        ))}
      </div>
    </section>);

};

// Projectes Comercials Section
const ProjectesComercialsSection = () => {
  return (
    <section
      id="commercial"
      className="md:pl-52 lg:pl-60 bg-[#F2ECE4]"
      data-testid="commercial-section">

      <div className="max-w-5xl mx-auto px-6 md:px-12 py-12 md:py-20">
        <div className="mb-12 md:mb-20">
          <p className="text-[#C5A059] font-sans text-xs tracking-[0.2em] uppercase mb-3">
            Treballs per a Empreses
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#1A1A1A]">
            Projectes Comercials
          </h2>
        </div>

        {commercialProjects.map((project) =>
        <GalleryItem
          key={project.id}
          image={project.image}
          title={project.title}
          subtitle={project.client}
          year={project.year} />

        )}
      </div>
    </section>);

};

// Interiors Section
const InteriorsSection = () => {
  return (
    <section
      id="interiors"
      className="md:pl-52 lg:pl-60 bg-[#F9F5F1]"
      data-testid="interiors-section">

      <div className="max-w-5xl mx-auto px-6 md:px-12 py-12 md:py-20">
        <div className="mb-12 md:mb-20">
          <p className="text-[#C5A059] font-sans text-xs tracking-[0.2em] uppercase mb-3">
            Pintura d'Interiors
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#1A1A1A]">
            Interiors
          </h2>
        </div>

        {interiorsProjects.map((project) =>
        <GalleryItem
          key={project.id}
          image={project.image}
          title={project.title}
          subtitle={project.category}
          year={project.year} />

        )}
      </div>
    </section>);

};

// Contacte Section
const ContacteSection = () => {
  return (
    <section
      id="contacte"
      className="md:pl-52 lg:pl-60 bg-[#F2ECE4]"
      data-testid="contacte-section">

      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="mb-10 md:mb-12">
          <p className="text-[#C5A059] font-sans text-xs tracking-[0.2em] uppercase mb-3">B.K.K

          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#1A1A1A] mb-8">
            Contacte
          </h2>
          <div className="w-12 h-[1px] bg-[#C5A059] mb-8"></div>
        </div>

        <div className="mb-12 md:mb-16">
          <p className="text-[#5A5A5A] font-sans text-base md:text-lg leading-relaxed mb-6">
            B:K, (Oriol Garreta) és un artista muralista nascut als Pirineus Catalans el 1999. Des del 2018 crea murals de gran format amb un estil figuratiu molt personal, que combina influències del graffiti i la cultura hip hop amb referències de la pintura clàssica com Velázquez o Caravaggio.
          </p>
          <p className="text-[#5A5A5A] font-sans text-base md:text-lg leading-relaxed mb-6">
            Format en Animació 3D i efectes visuals a la Universitat Ramon Llull de Barcelona, el seu treball destaca pel domini del color, la llum i el clarobscur, creant imatges impactants amb una pinzellada solta i expressiva. Els seus murals parteixen d'un esbós inicial però evolucionen de manera intuïtiva durant el procés, generant composicions versemblants amb un subtil toc surrealista.
          </p>
          <p className="text-[#5A5A5A] font-sans text-base md:text-lg leading-relaxed mb-6">
            El seu estil transforma espais amb obres plenes de caràcter i emoció, capaces d'atraure l'atenció i generar identitat visual. Des del 2019 ha participat en diversos festivals nacionals i internacionals, portant el seu llenguatge pictòric a espais públics i projectes per a diferents clients.
          </p>
          <p className="text-[#5A5A5A] font-sans text-base md:text-lg leading-relaxed">
            B:K ofereix murals personalitzats per a empreses, marques i espais que busquen una intervenció artística única que aporti valor estètic i personalitat al seu entorn.
          </p>
        </div>

        {/* Contact Info */}
        <div className="border-t border-[#E0D6CC] pt-10 md:pt-12">
          <div className="space-y-4">
            <a
              href="mailto:streetartpirineus@gmail.com"
              className="block font-sans text-lg md:text-xl text-[#1A1A1A] hover:text-[#C5A059] transition-colors"
              data-testid="contact-email">

              streetartpirineus@gmail.com
            </a>
            <a
              href="tel:+34646185970"
              className="block font-sans text-lg md:text-xl text-[#1A1A1A] hover:text-[#C5A059] transition-colors"
              data-testid="contact-phone">

              +34 646 185 970
            </a>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-16 md:mt-24 pt-8 border-t border-[#E0D6CC]">
          <p className="text-[#5A5A5A] text-xs font-sans">
            © {new Date().getFullYear()} {brandInfo.name}. Tots els drets reservats.
          </p>
        </div>
      </div>
    </section>);

};

// Main App Component
function App() {
  return (
    <div className="App bg-[#F9F5F1]" data-testid="app-container">
      <Navigation />
      <ObraPropiaSection />
      <ProjectesComercialsSection />
      <InteriorsSection />
      <ContacteSection />
    </div>);

}

export default App;